export class InvoiceRoutesI18n {
    public static InvoiceDetailTitle = 'Invoice Detail';
    public static UploadInvoicesNavigationLabel = 'Upload Unpaid Invoices';
    public static UploadInvoicesTitle = 'Upload Invoices';
}
